import axios from "axios";

const axiosURL = axios.create({
    baseURL: `https://findtables.ecu.cz`,
    withCredentials: true
   });
   
   export default axiosURL;